export default __webpack_public_path__ + "static/media/Ntorq125_LateralDer.aa24b9b3.webp";